module.exports = __webpack_public_path__ + "img/blueprint.9bd4fc3b.png";